import apiService from '../../../../services/api';
import {JobFilters, JobBrowseResponse } from '../types';
import { Job } from '../../../company/JobManagement/model/JobModel';

export const JobBrowsingApi = {
  browse: async (params: {
    limit: number;
    offset: number;
    query?: string;
    location?: string;
    job_type?: string;
    work_mode?: string;
    salary_min?: string;
  }): Promise<JobBrowseResponse> => {
    console.log('🔍 JobBrowsingApi.browse params:', params);
    console.log('📡 Expected URL:', `/jobs/browse?limit=${params.limit}&offset=${params.offset}`);
    const response = await apiService.get('/jobs/browse', params);
    return response.data;
  },

  getDetails: async (jobId: string): Promise<Job> => {
    const response = await apiService.get(`/jobs/browse/${jobId}`)
    return response.data;
  },

  apply: async (jobId: string, coverLetter?: string): Promise<any> => {
  const payload = coverLetter ? { cover_letter: coverLetter } : {};
  const response = await apiService.post(`/applications/jobs/${jobId}/apply`,payload);
  return response.data;
}

};
